import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import DashboardHomeView from './views/DashboardHomeView';
import VaultView from './views/VaultView';
import DevBoardView from './views/DevBoardView';
import SettingsView from './views/SettingsView';
import CodeGalleryView from './views/CodeGalleryView';
import TeamsView from './views/TeamsView';
import BillingView from './views/BillingView';
import DownloadsView from './views/DownloadsView';
import './prism-theme.css';
import { useAuth } from '@snipit/core/context/AuthContext';
import LoginView from './views/LoginView';
import LandingView from './views/LandingView';
import AdminView from './views/AdminView';
import OrgAdminView from './views/OrgAdminView';
import GeminiReviewView from './views/GeminiReviewView';
import DesktopAuthView from './views/DesktopAuthView';
import ContactView from './views/ContactView';
import AboutView from './views/AboutView';
import PrivacyView from './views/PrivacyView';
import LicenseView from './views/LicenseView';
import SecurityView from './views/SecurityView';
import ChangelogView from './views/ChangelogView';

function App() {
  const { currentUser } = useAuth();

  return (
    <Routes>
      <Route path="/desktop-auth" element={<DesktopAuthView />} />
      <Route path="/login" element={currentUser ? <Navigate to="/vault" replace /> : <LoginView />} />
      <Route path="/contact" element={<ContactView />} />
      <Route path="/about" element={<AboutView />} />
      <Route path="/privacy" element={<PrivacyView />} />
      <Route path="/license" element={<LicenseView />} />
      <Route path="/security" element={<SecurityView />} />
      <Route path="/changelog" element={<ChangelogView />} />
      <Route path="/" element={currentUser ? <Navigate to="/home" replace /> : <LandingView />} />
      
      <Route element={<DashboardLayout />}>
        <Route path="/home" element={<DashboardHomeView />} />
        <Route path="/vault" element={<VaultView />} />
        <Route path="/gallery" element={<CodeGalleryView />} />
        <Route path="/community" element={currentUser ? <DevBoardView /> : <Navigate to="/login" replace />} />
        <Route path="/teams" element={currentUser ? <TeamsView /> : <Navigate to="/login" replace />} />
        <Route path="/admin" element={currentUser ? <AdminView /> : <Navigate to="/login" replace />} />
        <Route path="/org-admin" element={currentUser ? <OrgAdminView /> : <Navigate to="/login" replace />} />
        <Route path="/review" element={currentUser ? <GeminiReviewView /> : <Navigate to="/login" replace />} />
        <Route path="/settings" element={<SettingsView />} />
        <Route path="/billing" element={<BillingView />} />
        <Route path="/downloads" element={<DownloadsView />} />
      </Route>
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
